// extracted by mini-css-extract-plugin
export var card = "_4j-0";
export var content = "_4j-1";
export var contentLoading = "_4j-2";